module.exports = __webpack_public_path__ + "static/media/arts_5.bdb540e5.jpg";